// Small shared form pieces for the public auth pages.
import React, { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useTranslation } from "react-i18next";

export function PasswordField({ label, value, onChange, autoComplete = "current-password", ...rest }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  return (
    <TextField
      label={label}
      type={show ? "text" : "password"}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      fullWidth
      inputProps={{ dir: "ltr" }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShow((s) => !s)}
              edge="end"
              aria-label={show ? t("mka_hide_password") : t("mka_show_password")}
              aria-pressed={show}
              size="small"
            >
              {show ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}

export function EmailField({ label, value, onChange, ...rest }) {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      autoComplete="email"
      fullWidth
      inputProps={{ inputMode: "email", dir: "ltr", autoCapitalize: "none", spellCheck: false }}
      {...rest}
    />
  );
}
